<template>
    <div>
        <div v-for="(stud_data, ind) in icard_data" :key="ind">
            <div class="container" style="background-color: white; height: 474px;">
                <div class="row" style="width: 18rem; height: 480px; background-color: white;">
                    <div class="secondarySection" v-if="stud_data.section == 'Secondary Section'">
                        <div class="ss_clgname">
                            <center>
                                <span>{{ stud_data.section }}</span>
                            </center>
                        </div>
                    </div>
                    <div class="primarySection" v-else-if="stud_data.section == 'Primary Section'">
                        <div class="ps_clgname">
                            {{ stud_data.section }}
                        </div>
                    </div>
                    <div class="priSection" v-else-if="stud_data.section == 'Pre-Primary Section'">
                        <div class="pps_clgname">
                            {{ stud_data.section }}
                        </div>
                    </div>
                    <div class="Section" v-else>
                        <div>
                            <center>
                                <span class="clgname">{{ stud_data.section }}</span>
                            </center>
                        </div>
                    </div>
                    <div class="col-10 cardArea" style="background-color: white; height: 462px;">
                        <div style="background-color: white;">
                            <img :src="common_data.logo" style="margin-left: 4px; width: 100%;" height="55"
                                alt="logo" />
                        </div>

                        <!-- ZIS changes code -->
                        <table v-if="common_data.org_id === 3">
                            <tr>
                                <td>
                                    <img width="17" height="15"
                                        src="https://vgespl-zeal.s3.ap-south-1.amazonaws.com/logo/i-card-image.jpeg" />
                                </td>
                                <td style="font-size: 0.8em; font-weight: bold; color: #023a9c; padding-bottom: 5px;">
                                    {{ common_data.heading }}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" align="center" style="font-size: 0.7em;">
                                    {{ common_data.school_address }}
                                </td>
                            </tr>
                        </table>

                        <!-- ZIS changes end -->
                        <center v-else-if="common_data.org_id == 2">
                            <div style="line-height: 100%;">
                                <span style="font-size: 15px; font-weight: bold;" v-html="common_data.heading"> </span>
                                <br />
                                <span style="font-size: 0.6em;font-weight: bold;">{{ common_data.school_address
                                    }}</span>
                                <br />
                            </div>
                        </center>
                        <!-- SCS code end -->
                        <center v-else>
                            <span style="font-size: 0.9em; font-weight: bold;" v-html="common_data.heading"> </span>

                            <br />

                            <span style="font-size: 0.6em;font-weight: bold;">{{ common_data.school_address }}</span>
                            <br />
                        </center>


                        <div class="empimg" v-if="common_data.org_id === 2">
                            <img style="background-color: white;" class="watermark-img" :src="common_data.watermark" />

                            <center>
                                <img :src="stud_data.profile_photo_path" class="box1 profile-img"
                                    style="width: 100px; height: 106px; margin-top: 8px; border: 1px solid black;" />
                            </center>

                            <center>
                                <div class="profile-name1" align="center">
                                    <h2 style="font-size: 0.8em;">{{ stud_data.name }}</h2>
                                </div>

                                <table class="profile-content1">
                                    <tr>
                                        <th>Std: {{ stud_data.std }}</th>
                                        <th>Div: {{ stud_data.div }}</th>
                                    </tr>
                                    <tr>
                                        <th v-if="!(common_data.org_id == 2 && stud_data.section == 'Pre-Primary Section')">House: {{ stud_data.house }}</th>
                                        <th>AY: {{ stud_data.ay }}</th>
                                    </tr>
                                    <tr v-if="common_data.org_id != 2">
                                        <th>
                                            Roll No.: {{ stud_data.rollno }}
                                        </th>
                                        <th></th>
                                    </tr>
                                </table>


                                <div class="barcoded profile-barcode1">
                                    <barcode height="20" width="2" v-model="stud_data.prn" v-bind:value="stud_data.prn">
                                    </barcode>
                                </div>
                            </center>
                        </div>

                        <!-- zis code for img -->
                        <div class="empimg" v-else>
                            <img style="background-color: white;" class="watermark-img-zis"
                                :src="common_data.watermark" />

                            <center>
                                <img :src="stud_data.profile_photo_path" class="box1 zis-img profile-img" />
                            </center>

                            <center>
                                <div class="profile-name" align="center">
                                    <h2 style="font-size: 0.9em;">{{ stud_data.name }}</h2>
                                </div>
                                <table class="profile-content">
                                    <tr>
                                        <th style="font-size: 0.7em;">Std: {{ stud_data.std }}</th>
                                        <th style="font-size: 0.7em;">Div: {{ stud_data.div }}</th>
                                    </tr>
                                    <tr>
                                        <th style="font-size: 0.7em;">
                                            House: {{ stud_data.house }}
                                        </th>
                                        <th style="font-size: 0.7em;">AY: {{ stud_data.ay }}</th>
                                    </tr>
                                    <tr v-if="common_data.org_id != 2">
                                        <th>
                                            Roll No.: {{ stud_data.rollno }}
                                        </th>
                                        <th></th>
                                    </tr>
                                </table>

                                <div class="barcoded-zis mt-5 profile-barcode" v-if="common_data.org_id === 3">
                                    <barcode height="20" width="2" v-model="stud_data.prn" v-bind:value="stud_data.prn">
                                    </barcode>
                                </div>
                                <div class="barcoded-zis mt-1 profile-barcode" v-else>
                                    <barcode height="20" width="2" v-model="stud_data.prn" v-bind:value="stud_data.prn">
                                    </barcode>
                                </div>
                            </center>
                        </div>
                        <!-- zis code for img end -->

                        <!-- zis barcode end -->
                        <div style="line-height: 1; margin-top: 13%;" v-if="common_data.org_id == 2">
                            <img :src="common_data.sign" style="width: 40%; height: auto; margin-left: 50%;"
                                alt="logo" />
                            <strong style="margin-left: 60%;">Principal</strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container pagebreak" style="background-color: white; height: 474px;">
                <div class="row cardback" style="width: 18rem;" v-if="stud_data != ''">
                    <div style="font-size: 0.83em; margin-left: 6%; width: 100%;">
                        <strong>Address : </strong>{{ stud_data.stud_address }}
                        <br />
                        <strong> Phone : </strong> {{ stud_data.stud_contact }}<br />
                        <template v-if="common_data.org_id != 3">
                            <strong> Emergency Contact: </strong>
                            {{ stud_data.emergency_contact_number }}<br />
                        </template>
                        <strong>D.O.B.: </strong> {{ stud_data.stud_dob }}<br />
                        <span v-if="!(common_data.org_id == 2 && stud_data.section == 'Pre-Primary Section')"><strong>Blood Group: </strong>{{ stud_data.stud_blood_group }}</span>
                        <template v-if="common_data.org_id == 1">
                            <br />
                            <strong>Admission Date: </strong>{{ stud_data.stud_doj }}
                        </template>
                        <br />
                    </div>
                    <br />
                    <div style="margin-left: 10%;">
                        <strong>Rules:-</strong>
                    </div>
                    <v-row dense v-for="(i, index) in common_data.instruction" :key="index">
                        <ul class="inst">
                            <li style="padding-left: 0.2em;">{{ i.topic }}</li>
                        </ul>
                    </v-row>
                    <div style="background-color: white;">
                        <table v-if="common_data.org_id == 1">
                            <tr>
                                <td>
                                    <img style="margin-left: 5%;"
                                        src="https://vgespl-zeal.s3.ap-south-1.amazonaws.com/logo/dems_qrcode.png"
                                        class="qrcode_dems" alt="logo" />
                                </td>
                                <th>
                                    <img :src="common_data.sign" alt="logo" class="sign2" style="margin-right: 5%;" />
                                    <span style="margin-left: 40%;">Principal</span>
                                </th>
                            </tr>
                        </table>
                        <table v-if="common_data.org_id == 2">
                            <tr>
                                <td>
                                    <img style="margin-left: 5%;"
                                        src="https://vgespl-zeal.s3.ap-south-1.amazonaws.com/logo/scs_qrcode.png"
                                        class="qrcode_scs" alt="logo" />
                                </td>
                                <th>
                                    <img :src="common_data.sign" alt="logo" class="sign_scs" /><br />
                                    <span style="margin-left: 45%;">Principal</span>
                                </th>
                            </tr>
                        </table>
                        <table v-if="common_data.org_id == 3">
                            <tr>
                                <td>
                                    <img style="margin-left: 5%;"
                                        src="https://vgespl-zeal.s3.ap-south-1.amazonaws.com/logo/zis_qrcode.png"
                                        class="qrcode_zis" alt="logo" />
                                </td>
                                <th>
                                    <img :src="common_data.sign" alt="logo" class="sign_zis" /><br />
                                    <span style="margin-left: 45%;">Principal</span>
                                </th>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    components: {
        barcode: VueBarcode,
    },
    data: () => ({
        comp_load: false,
        stud_list: null,
        radios: null,
        stud_data: null,
        child_data: null,
        icard_data: [],
        std: null,
        div: null,
        common_data: null,
        status: null,
    }),
    mounted() {
        this.std = localStorage.getItem("icard_std_id");
        this.div = localStorage.getItem("icard_div_id");
        this.status = localStorage.getItem("icard_learner_status");
        this.icardGenerateStudent();
    },

    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        onload() { },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        icardGenerateStudent() {
            const data = {
                std: this.std,
                div: this.div,
                status: this.status,
                usertype: "Student"
            };
            this.comp_load = false;
            axios
                .post("/Icard/bulkicardGenerateStudent", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.icard_data = res.data.icard_data;
                        this.common_data = res.data.common_data;
                    } else {
                        alert(res.data.snackbar);
                    }
                    this.comp_load = true;
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                    this.comp_load = false;
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
    },
};
</script>

<style scoped>
.dn {
    display: none;
}

th {
    text-align: left;
    font-size: 0.7em;
    padding-right: 15px;
    padding-left: 6px;
}

.cardbody {
    display: grid;
    grid-template-columns: auto auto auto;
    padding: 10px;
}

.secondarySection {
    background-color: blue;
    color: white;
    height: 29rem;
    margin-top: -0.3rem;
}

.ss_clgname {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    /*  for IE  */
    -webkit-transform: rotate(180deg);
    writing-mode: vertical-lr;
    font-size: 30px;
    transform-origin: center center;
    margin-top: 5.5rem;
    margin-right: 1px;
    text-transform: uppercase;
}

.primarySection {
    background-color: red;
    color: white;
    height: 29rem;
    margin-top: -0.3rem;
}

.ps_clgname {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    /*  for IE  */
    -webkit-transform: rotate(180deg);
    writing-mode: vertical-lr;
    font-size: 30px;
    transform-origin: center center;
    margin-top: 7rem;
    margin-right: 1px;
    text-transform: uppercase;
}

.priSection {
    background-color: yellow;
    color: black;
    height: 29rem;
    margin-top: -0.3rem;
}

.pps_clgname {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    /*  for IE  */
    -webkit-transform: rotate(180deg);
    writing-mode: vertical-lr;
    font-size: 30px;
    transform-origin: center center;
    margin-top: 4.4rem;
    margin-right: 1px;
    text-transform: uppercase;
}

.Section {
    background-color: red;
    color: white;
    height: 29rem;
    margin-top: -0.3rem;
}

.clgname {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    /*  for IE  */
    -webkit-transform: rotate(180deg);
    writing-mode: vertical-lr;
    font-size: 32px;
    transform-origin: center center;
    margin-top: 8rem;
    margin-right: 1px;
    text-transform: uppercase;
}

.clgname1 {
    writing-mode: vertical-lr;
    transform: rotate(-180deg);
    -ms-transform: rotate(180deg);
    /*  for IE  */
    -webkit-transform: rotate(180deg);
    font-size: 32px;
    text-align: center;
    vertical-align: middle;
    text-transform: uppercase;
}

.ay {
    font-size: 13px;
    writing-mode: tb;
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    /*  for IE  */
    -webkit-transform: rotate(180deg);
    margin-top: 240px;
    margin-bottom: -75px;
    margin-left: 23px;
    text-transform: uppercase;
    height: 50px;
}

.cardArea {
    padding: 0;
    padding-left: 6px;
}

.qrcode_dems {
    width: 45%;
    height: auto;
}

.qrcode_scs {
    width: 65%;
    height: auto;
    margin-top: 1rem;
}

.qrcode_zis {
    width: 80%;
    height: auto;
    margin-top: 1rem;
}

.sign2 {
    width: 150%;
    height: auto;
    margin-top: 1rem;
    padding-right: 20px;
}

.sign_scs {
    width: 85%;
    height: auto;
    margin-top: 1rem;
    padding-left: 2rem;
}

.sign_zis {
    width: 150px;
    height: auto;
    padding-left: 1rem;
}

.cardback {
    /* height: 30rem; */
    /* height: 480px; */
}

@media print {
    .Section {
        width: 40px;
    }

    .secondarySection {
        width: 40px;
    }

    .primarySection {
        width: 40px;
    }

    .priSection {
        width: 40px;
    }

    .pagebreak {
        page-break-before: always !important;
    }

    @page {
        margin: -0.2645833mm;
        size: 53mm 86.614mm;
    }
}

ul.inst {
    list-style-type: "*";
    font-weight: 500;
    font-size: 14px;
}

.zis-img {
    width: 50%;
    height: 140px;
    margin-top: 8px;
    border: 1px solid black;
}

.watermark-img {
    height: 225px;
    width: 83%;
}

.watermark-img-zis {
    height: 315px;
    width: 83%;
}

.empimg {
    position: relative;
}

.profile-img {
    position: absolute;
    top: 1%;
    right: 28%;
}

.profile-content {
    position: absolute;
    top: 52%;
    left: 8%;
}

.profile-barcode {
    position: absolute;
    top: 75%;
    width: 100%;
}

.profile-name {
    position: absolute;
    top: 47%;
    width: 100%;
}

.profile-name1 {
    position: absolute;
    top: 50%;
    width: 100%;
}

.profile-barcode1 {
    position: absolute;
    top: 82%;
    width: 100%;
}

.profile-content1 {
    position: absolute;
    top: 60%;
    left: 8%;
}
</style>
